import StyledLink from '../StyledLink'
import useModule from '../../hooks/useModule'
import {
  CONTROLLER,
  DUPLICATE,
  MONITOR,
  MONITOR_CONFIG,
  TEST_CONFIG
} from '../routes'
import type { Props } from '../types'

interface Params {
  testConfigId: string
}

const LinkToDuplicateTestConfig = ({
  children,
  testConfigId,
  openInNewTab,
  isHyperlink
}: (Props & Params)) => {
  const [isMonitorFlag] = useModule()

  const base = !isMonitorFlag
    ? '/' + CONTROLLER + '/' + TEST_CONFIG + '/'
    : '/' + MONITOR + '/' + MONITOR_CONFIG + '/'

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      openInNewTab={openInNewTab}
      to={base + testConfigId + '/' + DUPLICATE}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToDuplicateTestConfig
